<template>
  <div class="smy__card-full-box">
    <Card :bordered="false" class="smy__card-full">
      <p slot="title">到期提醒</p>
      <div class="search">
        <!-- 详细筛选条件 -->
        <div>
          <div
            class="search-detail"
            :class="{ 'search-detail-close': !searchVisible }"
            :style="{ overflow: !searchVisible ? 'hidden' : '' }"
          >
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入企业名称"
                v-model="searchForm.epName"
              ></Input>
            </div>
            <div class="search-detail-item">
              <Input
                class="search-input"
                placeholder="请输入corpID"
                v-model="searchForm.corpId"
              ></Input>
            </div>
            <div class="search-detail-item">
              <DateRangePicker
                class="search-input"
                placement="bottom-end"
                :placeholder="'筛选提醒时间'"
                :value="emptyDate"
                @on-change="
                  daterangeChange($event, 'start_createtime', 'end_createtime')
                "
              />
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="提醒内容"
                element-id="codetype"
                v-model="searchForm.code"
              >
                <Option
                  v-for="codeType in codeList"
                  :key="codeType.id"
                  :value="codeType.id"
                >
                  {{ codeType.name }}
                </Option>
              </Select>
            </div>
            <div class="search-detail-item">
              <Select
                clearable
                filterable
                class="search-input"
                placeholder="专属客服"
                element-id="sysrole"
                v-model="searchForm.customServiceId"
              >
                <Option
                  v-for="sysrole in sysroleList"
                  :key="sysrole.id"
                  :value="sysrole.id"
                >
                  {{ sysrole.name }}
                </Option>
              </Select>
            </div>

            <div class="search-detail-item">
              <Button
                type="primary"
                class="search-button"
                @click=";(pageIndex = 0), loadList()"
              >
                查找
              </Button>
              <Button class="search-button" @click="resetSearchForm">
                重置
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div class="button-group">
        <Button-group>
          <i-button
            :type="searchForm.process_state === 0 ? 'primary' : 'ghost'"
            @click="undealSearchForm"
          >
            未处理
          </i-button>
          <i-button
            :type="searchForm.process_state === 1 ? 'primary' : 'ghost'"
            @click="dealSearchForm"
          >
            已处理
          </i-button>
        </Button-group>
      </div>
      <!-- 工单列表 -->
      <div class="table table-sticky">
        <Table
          stripe
          ref="table"
          :loading="listLoading"
          :columns="columns"
          :data="list"
        ></Table>
      </div>
      <!-- 分页控件 -->
      <Page
        show-total
        show-sizer
        class="page"
        placement="top"
        :current="pageIndex + 1"
        :total="count"
        :page-size-opts="pageSizeOpts"
        @on-change="pageIndexChange"
        @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
    <!--新增跟进记录-->
    <NewFollowUpRecords
      :agentId="agentId"
      :followUpRecModal="followUpRecModal"
      :followUpRecTitle="editTitle"
      :followUpRecRow="editRow"
      @callback="loadList()"
      @backeditModal="followUpRecModal = false"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import DateRangePicker from '@/components/DateRangePicker'

import NewFollowUpRecords from '../followCustomList/NewFollowUpRecords'
export default {
  name: 'RemindList',
  components: {
    DateRangePicker,
    NewFollowUpRecords,
  },
  data() {
    return {
      orderModalShow: false, // 购买弹窗
      emptyDate: ['', ''],
      chouseState: '',
      currPackageId: 1,
      buyPeople: '',
      busType: '',
      corpid: '',
      type: 1,
      searchVisible: true, // 是否显示详细筛选条件
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      sysrole: 8, // 客服下拉框所需的参数
      sysroleList: [], // 客服下拉数据
      searchForm: {
        code: '', // 提醒内容类型 -1 全部 1 到期提醒 2 3天到期提醒 3 7天到期提醒  4 5天到期提醒 5 12天到期提醒
        process_state: 1, // 处理状态 -1 全部 0 未处理 1 已处理
        epName: '', // 企业名称
        corpId: '', // 企业corpid
        customServiceId: '', // 客服id
        start_createtime: '', // 提醒开始时间
        end_createtime: '', // 提醒结束时间
      },
      agentId: 1,
      followUpRecModal: false,
      editTitle: '编辑联系人',
      editRow: {},
      editModal: false,
      codeList: [
        // 提醒内容类型
        // {
        //   id: '4',
        //   name: '5天到期提醒'
        // },
        // {
        //   id: '5',
        //   name: '12天到期提醒'
        // }
        {
          id: '11',
          name: '新开通企业提醒',
        },
        {
          id: '190',
          name: '付费用户前3个月提醒',
        },
        {
          id: '130',
          name: '付费用户前1个月提醒',
        },
        {
          id: '115',
          name: '付费用户前15天提醒',
        },
        {
          id: '105',
          name: '付费用户前5天提醒',
        },
        {
          id: '101',
          name: '付费用户前1天提醒',
        },
        {
          id: '212',
          name: '试用用户前12天提醒',
        },
        {
          id: '205',
          name: '试用用户前5天提醒',
        },
        {
          id: '201',
          name: '试用用户前1天提醒',
        },
      ],
      packageNumber: [
        {
          value: '1',
          name: '报备中',
        },
        {
          value: '2',
          name: '免费版',
        },
        {
          value: '3',
          name: '试用版',
        },
        {
          value: '4',
          name: 'VIP版',
        },
        {
          value: '5',
          name: 'VIP到期',
        },
        {
          value: '6',
          name: '报备失败',
        },
      ],
    }
  },
  computed: {
    ...mapState('table', ['columnsCheckedAll', 'pageSizeOpts']),
    // 表格列 根据选中的列动态生成
    columns() {
      const allColumns = [
        {
          title: '操作',
          width: 250,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let check = h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'ghost',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      let url = '/enterprise/mgr/call'
                      let data = {
                        epId: row.id,
                      }
                      this.$http.post(url, data).then((res) => {
                        if (res.success) {
                          let msg = '拨打成功'
                          this.$Message.success(msg)
                          this.loadList()
                        } else {
                          this.$Message.error(res.message)
                        }
                      })
                    },
                  },
                  style: {
                    marginLeft: '10px',
                    marginTop: '5px',
                    marginBottom: '5px',
                  },
                },
                ['智能电话']
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'ghost',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.editTitle = '新增跟进记录'
                      this.agentId = row.id
                      this.editRow = row
                      this.followUpRecModal = true
                    },
                  },
                  style: {
                    marginLeft: '10px',
                    marginTop: '5px',
                    marginBottom: '5px',
                  },
                },
                ['新增跟进记录']
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'ghost',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: 'FollowDetail',
                        params: { orderId: row.ep_id },
                      })
                    },
                  },
                  style: {
                    marginLeft: '10px',
                  },
                },
                ['查看详情']
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'ghost',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      let url = '/message/unprocess'
                      let data = {
                        id: row.id,
                      }
                      this.$http.post(url, data).then((res) => {
                        if (res.success) {
                          this.loadList()
                        } else {
                          this.$Message.error(res.message)
                        }
                      })
                    },
                  },
                  style: {
                    marginLeft: '10px',
                  },
                },
                ['置为未处理']
              ),
            ])

            let check2 = h('div', [
              h(
                'Button',
                {
                  props: {
                    type: 'ghost',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      let url = '/enterprise/mgr/call'
                      let data = {
                        epId: row.id,
                      }
                      this.$http.post(url, data).then((res) => {
                        if (res.success) {
                          let msg = '拨打成功'
                          this.$Message.success(msg)
                          this.loadList()
                        } else {
                          this.$Message.error(res.message)
                        }
                      })
                    },
                  },
                  style: {
                    marginLeft: '10px',
                    marginTop: '5px',
                    marginBottom: '5px',
                  },
                },
                ['智能电话']
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'ghost',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.editTitle = '新增跟进记录'
                      this.agentId = row.id
                      this.editRow = row
                      this.followUpRecModal = true
                    },
                  },
                  style: {
                    marginLeft: '10px',
                    marginTop: '5px',
                    marginBottom: '5px',
                  },
                },
                ['新增跟进记录']
              ),
              h(
                'Button',
                {
                  props: {
                    type: 'ghost',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: 'FollowDetail',
                        params: { orderId: row.ep_id },
                      })
                    },
                  },
                  style: {
                    marginLeft: '10px',
                  },
                },
                ['查看详情']
              ),

              h(
                'Button',
                {
                  props: {
                    type: 'ghost',
                    size: 'small',
                  },
                  on: {
                    click: () => {
                      let url = '/message/processed'
                      let data = {
                        id: row.id,
                      }
                      this.$http.post(url, data).then((res) => {
                        if (res.success) {
                          this.loadList()
                        } else {
                          this.$Message.error(res.message)
                        }
                      })
                    },
                  },
                  style: {
                    marginLeft: '10px',
                  },
                },
                ['置为已处理']
              ),
            ])
            if (row.process_state === 1) {
              return h('div', [check])
            } else {
              return h('div', [check2])
            }
          },
        },
        {
          title: '提醒时间',
          key: 'createtime',
          width: 180,
        },
        {
          title: '提醒内容',
          key: 'code',
          width: 140,
          render: (h, { row }) => {
            let codeType = row.code
            let code = ''
            if (codeType === 11) {
              code = '新开通企业提醒'
            } else if (codeType === 190) {
              code = '付费用户前3个月提醒'
            } else if (codeType === 130) {
              code = '付费用户前1个月提醒'
            } else if (codeType === 115) {
              code = '付费用户前15天提醒'
            } else if (codeType === 105) {
              code = '付费用户前5天提醒'
            } else if (codeType === 101) {
              code = '付费用户前1天提醒'
            } else if (codeType === 212) {
              code = '试用用户前12天提醒'
            } else if (codeType === 205) {
              code = '试用用户前5天提醒'
            } else if (codeType === 201) {
              code = '试用用户前1天提醒'
            }
            return h('span', [code])
          },
        },
        {
          title: '企业ID',
          key: 'ep_id',
          width: 140,
          ellipsis: true,
        },
        {
          title: '企业名称',
          key: 'ep_name',
          width: 140,
        },
        {
          title: 'CorpID',
          key: 'corpid',
          width: 180,
          ellipsis: true,
        },
        {
          title: '专属客服',
          key: 'customservice_name',
          width: 140,
        },
        {
          title: '到期时间',
          key: 'service_expire_time',
          width: 180,
        },
        {
          title: ' ',
          key: ' ',
        },
      ]
      return allColumns
    },
  },
  watch: {
    chouseState(val) {},
  },
  methods: {
    // 加载列表数据
    loadList() {
      this.listLoading = true
      this.$http
        .all([
          this.$http.get('/message/list', {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              ...this.searchForm,
            },
          }),

          this.$http.get('/message/count', {
            params: this.searchForm,
          }),

          this.$http.get('/user/listBySysrole', {
            params: {
              sysrole: this.sysrole,
            },
          }),
        ])
        .then(
          this.$http.spread((res1, res2, res3) => {
            if (res1.success && res2.success && res3.success) {
              this.list = res1.data
              this.count = res2.data
              this.sysroleList = res3.data
              this.listLoading = false
            }
          })
        )
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    daterangeChange(daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0]
          .replace('/', '-')
          .replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      this.emptyDate = [this.searchForm[start], this.searchForm[end]]
    },
    // 重置搜索框
    resetSearchForm() {
      this.chouseState = ''
      this.emptyDate = ['', '']
      this.searchForm = {
        code: '', // 提醒内容类型 -1 全部 1 到期提醒 2 3天到期提醒 3 7天到期提醒
        process_state: 1, // 处理状态 -1 全部 0 未处理 1 已处理
        epName: '', // 企业名称
        corpId: '', // 企业corpid
        customServiceId: '', // 客服id
        start_createtime: '', // 提醒开始时间
        end_createtime: '', // 提醒结束时间
      }
      this.loadList()
    },
    // 已处理
    dealSearchForm() {
      this.searchForm.process_state = 1
      this.loadList()
    },
    // 未处理
    undealSearchForm() {
      this.searchForm.process_state = 0
      this.loadList()
    },
  },
  created() {
    this.$http.get('/dropdown/industry').then((res) => {
      this.busType = res.data
    })
    this.$http.get('/dropdown/chargePackage').then((res) => {
      this.buyPeople = res.data
    })
    this.loadList()
  },
}
</script>

<style lang="less" scoped>
.search {
  // margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    height: 90px;
    transition: 0.5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }

    .search-detail-item:nth-child(2n + 1),
    .search-detail-item:nth-child(4n + 2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}

.button-group {
  margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/customManage/remindList/index.vue